import { Box, SxProps } from "@mui/material";
import { DatasetAccessLevel } from "datasets/types/enums/access-level";

const OwnerChip = ({
  accessLevel,
  sx,
}: {
  accessLevel: DatasetAccessLevel | null;
  sx?: SxProps;
}) => {
  if (accessLevel !== DatasetAccessLevel.OWNER) {
    return null;
  }

  return (
    <Box
      data-testid="dataset-owner-chip"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 10,
        letterSpacing: "0.04em",
        fontWeight: 600,
        height: "18px",
        borderRadius: "99px",
        color: "grey.700",
        backgroundColor: "grey.100",
        ...sx,
      }}
    >
      Owner
    </Box>
  );
};

export default OwnerChip;
